import React, { Component } from 'react';
import { Form, Input, DatePicker, Select } from 'antd';
import { FormLayout } from '@/components';
import { dispatch } from '@@/store';
import { CHECK_name, CHECK_phone, CHECK_buyerCode, CHECK_num_letter_range } from '@/shared/reqexp';
import moment from 'moment';
import Mapping from '@/shared/mapping';
const Option = Select.Option;
class FormSearch extends Component {
    constructor(props) {
        super(props);
        this.search = (data) => {
            dispatch.buyer.SET_STATE({
                searchData: data,
            });
            dispatch.buyer.updateTable({ pageIndex: 1 });
        };
        this.state = {};
    }
    dealDate(currentDate) {
        const now = moment();
        return currentDate > now;
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (<FormLayout form={this.props.form} onSearch={this.search}>
        <Form.Item label={'姓名'}>
          {getFieldDecorator('realName', {
            rules: [
                {
                    validator: CHECK_name(50),
                },
            ],
        })(<Input placeholder={'请输入姓名'}/>)}
        </Form.Item>
        <Form.Item label={'手机号'}>
          {getFieldDecorator('mobile', {
            rules: [
                {
                    pattern: CHECK_phone,
                    message: '请输入正确格式的手机号',
                },
            ],
        })(<Input placeholder={'请输入手机号'}/>)}
        </Form.Item>
        <Form.Item label={'身份证号'}>
          {getFieldDecorator('contactCode', {
            rules: [
                {
                    pattern: CHECK_num_letter_range(18),
                    message: '请输入正确的身份证号(最多18位)',
                },
            ],
        })(<Input placeholder={'请输入身份证号'}/>)}
        </Form.Item>
        <Form.Item label={'号牌'}>
          {getFieldDecorator('numberPlate', {
            rules: [
                {
                    pattern: CHECK_buyerCode,
                    message: '请输入3位数字号牌(000-999)',
                },
            ],
        })(<Input placeholder={'请输入号牌'}/>)}
        </Form.Item>
        <Form.Item label={'类型'}>
          {getFieldDecorator('userType', { initialValue: '' })(<Select getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
              {Mapping.buyerType.map((item) => {
            return (<Option value={item.value} key={item.value}>{item.label}</Option>);
        })}
            </Select>)}
        </Form.Item>
        <Form.Item label={'买家添加时间'} wrapperCol={{ span: 16 }}>
          {getFieldDecorator('time')(<DatePicker.RangePicker className={'width-100'} disabledDate={this.dealDate} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}/>)}
        </Form.Item>
      </FormLayout>);
    }
}
const FormSearchForm = Form.create({})(FormSearch);
export default FormSearchForm;
